export enum Pages {
  OPTIN = 'optin',
  SURVEY = 'survey',
  CONFIRMATION = 'confirmation',
}

export interface LeadCompletedResponse {
  message: string;
  has_completed_snhu: boolean;
}
